export const SUPPORTED_LOCALES = ["en", "zh-Hant", "it", "ja"] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = "en";

export const LOCALE_STORAGE_KEY = "webapp2.locale";

export const LOCALE_LABELS: Record<AppLocale, string> = {
    en: "English",
    "zh-Hant": "繁體中文",
    it: "Italiano",
    ja: "日本語",
};

export function isAppLocale(value: string): value is AppLocale {
    return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function loadStoredLocale(): AppLocale {
    try {
        const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
        if (stored && isAppLocale(stored)) {
            return stored;
        }
    } catch {
        /* ignore */
    }
    return DEFAULT_LOCALE;
}

export function persistLocale(locale: AppLocale): void {
    try {
        localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    } catch {
        /* ignore */
    }
}

export function applyDocumentLang(locale: AppLocale): void {
    document.documentElement.lang = locale;
}
